export default {
  FETCH_SFTP_LIST_REQUEST: 'FETCH_SFTP_LIST_REQUEST',
  FETCH_SFTP_LIST_SUCCESS: 'FETCH_SFTP_LIST_SUCCESS',
  FETCH_SFTP_LIST_FAILURE: 'FETCH_SFTP_LIST_FAILURE',

  DELETE_SFTP_BY_ID_REQUEST: 'DELETE_SFTP_BY_ID_REQUEST',
  DELETE_SFTP_BY_ID_SUCCESS: 'DELETE_SFTP_BY_ID_SUCCESS',
  DELETE_SFTP_BY_ID_FAILURE: 'DELETE_SFTP_BY_ID_FAILURE',

  FETCH_SFTP_BY_ID_REQUEST: 'FETCH_SFTP_BY_ID_REQUEST',
  FETCH_SFTP_BY_ID_SUCCESS: 'FETCH_SFTP_BY_ID_SUCCESS',
  FETCH_SFTP_BY_ID_FAILURE: 'FETCH_SFTP_BY_ID_FAILURE',

  UPDATE_SFTP_BY_ID_REQUEST: 'UPDATE_SFTP_BY_ID_REQUEST',
  UPDATE_SFTP_BY_ID_SUCCESS: 'UPDATE_SFTP_BY_ID_SUCCESS',
  UPDATE_SFTP_BY_ID_FAILURE: 'UPDATE_SFTP_BY_ID_FAILURE',

  CREATE_SFTP_REQUEST: 'CREATE_SFTP_REQUEST',
  CREATE_SFTP_SUCCESS: 'CREATE_SFTP_SUCCESS',
  CREATE_SFTP_FAILURE: 'CREATE_SFTP_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/actions/action-types.js